import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import { isLoggedIn } from '../api/Auth';

import AvatarPopover from './AvatarPopover';

const Avatar = ({
  id,
  className,
  user,
  size,
  icon,
  stacked,
  tooltip,
  expandable,
}) => {
  const intl = useIntl();
  let uId = id;
  if (!uId) {
    uId = (user && user.uuid) ? user.uuid : uuidv4();
  }
  const elId = `avatar-${uId}`;

  const background = true;

  return (
    <div
      className={classnames('avatar-component', className, { expandable })}
      style={{ marginRight: stacked ? ((size / 2) * -1) : undefined }}
    >
      {(user && user.avatar_url) ? (
        <div id={elId} className={classnames('user-avatar', { 'user-avatar-pointer-none': !isLoggedIn() })}>
          {background ? (
            <div style={{ backgroundImage: `url(${user.avatar_url})` }} className={classnames('avatar', `avatar-${size}`, { 'outline-avatar': stacked })} />
          ) : (
            <img src={user.avatar_url} alt={user.name} className={classnames('avatar', `avatar-${size}`, { 'outline-avatar': stacked })} />
          )}
        </div>
      ) : (
        <div id={elId} className={classnames('user-avatar', { 'user-avatar-pointer-none': !user })}>
          <div className={classnames('avatar icon-avatar gray', `avatar-${size}`, { 'outline-avatar': stacked })}>
            <i className={`fas fa-${icon}`} />
          </div>
        </div>
      )}
      {(tooltip && user && user.uuid && isLoggedIn()) && (
        <UncontrolledTooltip fade={false} target={elId}>
          {user.type === 'group' ? intl.formatMessage({ defaultMessage: 'Team{nbsp}' }, { nbsp: ' ' }) : ''}
          {user.name}
        </UncontrolledTooltip>
      )}
      {(expandable && user && isLoggedIn()) && (
        <AvatarPopover
          user={user}
          targetId={elId}
        />
      )}
    </div>
  );
};

Avatar.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  user: PropTypes.object,
  size: PropTypes.number,
  icon: PropTypes.string,
  stacked: PropTypes.bool,
  tooltip: PropTypes.bool,
  expandable: PropTypes.bool,
};

Avatar.defaultProps = {
  id: '',
  className: '',
  user: null,
  size: 40,
  icon: 'user',
  stacked: false,
  tooltip: false,
  expandable: false,
};

export default Avatar;
